<script>
    import options from "@/constants/options";

    export default {
        name: 'MBaseFormElement',
        props: {
            formKey: undefined,
            value: undefined,
            loading: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: undefined
            },
            readonly: {
                type: Boolean,
                default: false
            },
            label: {
                type: [String, Function],
                default: undefined
            },
            rules: {
                type: [Array],
                default: () => [v => true]
            },
            checkError: {
                type: Boolean,
                default: false,
            },
            errorMessage: {
                type: String,
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: false
            },
            optionsData: {
                type: Object,
                default: undefined
            },
            inEditMode: {
                type: Boolean,
                default: false,
            },
            fullWidthLabel: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
          orgData: {
            type: Object,
            default: undefined
          },
        },
        data() {
            return {
                model: this.value,
                updateData: null,
            }
        },
        computed: {
            contentAlign() {
                return this.fullWidthLabel === true ? "left" : "right";
            },

            labelCols() {
              if (this.options.denseMode){
                return 5
              }
                return this.fullWidthLabel === true ? 12 : 4;
            },

            contentCols() {
              if (this.options.denseMode){
                return 7
              }
                return this.fullWidthLabel === true ? 12 : 8;
            },

            options() {
                return !!this.optionsData && typeof this.optionsData === 'object' ? this.optionsData : {};
            },
        },
        watch: {
            value(newValue, oldValue) {
                this.model = newValue;
            },
            model(newValue, oldValue) {
                this.$emit('input', newValue);
            },
            updateData(newValue, oldValue) {
                this.$emit("update:data", newValue);
            },
        },
    }
</script>
